var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('section', {
    staticClass: "activity-stage"
  }, [_vm.currentRound.image ? _c('img', {
    attrs: {
      "src": _vm.currentRound.image
    }
  }) : _vm._e(), _c('div', {
    attrs: {
      "id": "steps"
    }
  }, [_c('text-display-list', {
    attrs: {
      "id": "input",
      "text-size": "medium"
    }
  }, _vm._l(_vm.currentRound.steps, function (step) {
    return _c('blinking-cursor-text', {
      key: ("step" + (step.stepIndex)),
      attrs: {
        "text": step.answer,
        "text-step": step.stepIndex
      }
    });
  }), 1)], 1), _vm._t("keyboard")], 2)]);
}
var staticRenderFns = []

export { render, staticRenderFns }